import { dataListUnordered } from 'dls-icons-data'
import { createIcon } from '../common'

const IconListUnordered = /*#__PURE__*/createIcon(dataListUnordered)
export default IconListUnordered
